import React from "react";

export const DottedHamburger = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.75 2.55H18.75M6.75 9.75H18.75M6.75 16.95H18.75M4.35 2.55C4.35 3.54411 3.54411 4.35 2.55 4.35C1.55589 4.35 0.75 3.54411 0.75 2.55C0.75 1.55589 1.55589 0.75 2.55 0.75C3.54411 0.75 4.35 1.55589 4.35 2.55ZM4.35 9.75C4.35 10.7441 3.54411 11.55 2.55 11.55C1.55589 11.55 0.75 10.7441 0.75 9.75C0.75 8.75589 1.55589 7.95 2.55 7.95C3.54411 7.95 4.35 8.75589 4.35 9.75ZM4.35 16.95C4.35 17.9441 3.54411 18.75 2.55 18.75C1.55589 18.75 0.75 17.9441 0.75 16.95C0.75 15.9559 1.55589 15.15 2.55 15.15C3.54411 15.15 4.35 15.9559 4.35 16.95Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
